import { Button } from "components/Button/Button";
import { ActionDropdownButton } from "components/DropdownButton/ActionDropdownButton";
import { IconCollection } from "components/Icon/IconCollection";
import { getNewRecordPath } from "components/Layout/Sidebar/components/CreateNew/CreateNew";
import { schedulerKey } from "containers/Resources/screens/ResourcesSingle/constants";
import { getAdditionalSubmitFormParams } from "containers/Resources/screens/ResourcesSingle/utils";
import { History } from "history";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

const schedulingBundleSchedulerName = "scheduling-bundle-scheduler";

export const createScheduleAction = ({
    recordId,
    schedulerId,
    history,
}: {
    recordId?: string;
    schedulerId?: string;
    history: History;
}) => {
    const flowIdParam = recordId ? { flow_id: recordId } : {};
    const schedulerIdParam = schedulerId ? { scheduler_id: schedulerId } : {};
    const params = getAdditionalSubmitFormParams(flowIdParam, schedulerIdParam);
    history.push(getNewRecordPath("schedule", params));
};

export const getSchedulingBundleSchedulerId = (schedulerList) =>
    schedulerList?.find(({ name }) => name === schedulingBundleSchedulerName)?.id;

export const getAdditionalSchedulerList = (schedulerList) =>
    schedulerList?.filter(({ name }) => name !== schedulingBundleSchedulerName) ?? [];

export const CreateScheduleDropdownContent = ({ isFieldDisabled, action, schedulerList }: any) => {
    const additionalSchedulerList = getAdditionalSchedulerList(schedulerList);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                minWidth: "200px",
            }}
        >
            {additionalSchedulerList.map(({ id, name }) => (
                <Button
                    key={id}
                    label={name}
                    icon={IconCollection.timetable}
                    disabled={isFieldDisabled}
                    variation="clear"
                    className="wide"
                    onClick={() => action(id)}
                />
            ))}
        </div>
    );
};

export const CreateScheduleButton = ({
    isFieldDisabled,
    recordId,
}: {
    isFieldDisabled: boolean;
    recordId: string;
}) => {
    const history = useHistory();
    const schedulerList = useSelector(
        (state: any) => state?.dataStore?.[schedulerKey]
    )?.scheduler_plain_list;

    const action = useCallback(
        (schedulerId) => {
            createScheduleAction({ recordId, schedulerId, history });
        },
        [history, recordId]
    );
    const schedulingBundleSchedulerId = getSchedulingBundleSchedulerId(schedulerList);
    const additionalSchedulerList = getAdditionalSchedulerList(schedulerList);

    return additionalSchedulerList.length ? (
        <ActionDropdownButton
            parentAction={() => action(schedulingBundleSchedulerId)}
            label="Create schedule"
            icon={IconCollection.timetable}
            isDisabled={isFieldDisabled}
            key={"create schedule"}
        >
            <CreateScheduleDropdownContent
                isFieldDisabled={isFieldDisabled}
                recordId={recordId}
                schedulerList={schedulerList}
                action={action}
            />
        </ActionDropdownButton>
    ) : (
        <Button
            label="Create schedule"
            icon={IconCollection.timetable}
            disabled={isFieldDisabled}
            onClick={() => action(schedulingBundleSchedulerId)}
            variation="dark"
        />
    );
};
